// Módulo 1: Introducción a la Tokenización
import token1 from './1';
import token2 from './1a';
import token3 from './1b';
import token4 from './1aa';
import token5 from './1c';
import token6 from './2';
import token7 from './3';
import token8 from './4';


// Módulo 2: Introducción a la Tokenización
import token9 from './5';
import token10 from './6';
import token11 from './7_0';
import token12 from './7';
import token13 from './7_1';
import token14 from './8';
import token15 from './8a';
import token16 from './9';
import token17 from './9a';
import token18 from './9b';
import token19 from './10';

// Modulo 3
import token20 from './10b';
import token21 from './10c';
import token22 from './10d';
import token23 from './10e';
import token24 from './10f';
import token25 from './10g';
import token26 from './11';
import token27 from './11a';
import token28 from './11b';
import token29 from './12';
import token30 from './13';
import token31 from './14';
import token32 from './15';
import token33 from './16';
import token34 from './17';
import token35 from './18';


// Module 4
import token36 from './19';
import token37 from './20';


// Module 5
import token38 from './21a';
import token39 from './21';


// Module 6
import token40 from './20_0';
import token41 from './201';
import token42 from './20_2';



// Agrupados por módulo
const module1 = [...token1, ...token2, ...token3, ...token4, ...token5,...token6,...token7,...token8];
const module2 = [...token9,...token10,...token11,...token12,...token13,...token14,...token15,...token16,...token17,...token18,...token19,];
const module3 = [...token20,...token21,...token22,...token23,...token24,...token25,...token26,...token27,...token28,...token29,...token30,...token31,...token32,...token33,...token34,...token35,];
const module4 = [...token36,...token37,];
const module5 = [...token38,...token39,];
const module6 = [...token40,...token41,...token42];
// Unión de todos los módulos
const tokenProject = [...module1, ...module2, ...module3, ...module4,module5,module6];

// Export individual y global
export { tokenProject, module1, module2, module3, module4,module5,module6};
